import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhySection from './components/WhySection';
import AboutSection from './components/AboutSection';
import HowItWorks from './components/HowItWorks';
import PrivacySection from './components/PrivacySection';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <WhySection />
      <AboutSection />
      <HowItWorks />
      <PrivacySection />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
